import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// 导入组件

// 全局注册组件
Vue.component('svg-icon', SvgIcon)

// 自动导入所有svg文件
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('@/assets/icons', false, /\.svg$/)
requireAll(req)
